import Adicionar from './Adicionar';
import Editar from './Editar';
import Lista from './Lista';

export const BibliografiaAdicionar = Adicionar;
export const BibliografiaEditar = Editar;
export const BibliografiaLista = Lista;
